import React from 'react';
import { Transform } from 'react-animation-components';
import Message from '../components/Message/Message';

const Intro = ({ header, children, hasError, footer }) => (
    <div className="container">
        {header}
        <Transform in={hasError} className="page-body" enterTransform="translateY(50px)">
            <div className="page-content">
                {hasError ? (
                    <Transform
                        in
                        duration={500}
                        style={{ zIndex: 997 }}
                        enterTransform="translateY(-50px)"
                        exitTransform="translateY(-50px)">
                        <Message
                            type="error"
                            name="error-message"
                            datacy="error-message"
                            message="Something went wrong, please try again later."
                        />
                    </Transform>
                ) : null}
                {children}
            </div>
        </Transform>
        {footer}
    </div>
);

export default Intro;



// WEBPACK FOOTER //
// ./src/templates/Intro.jsx